<template>
  <div class="sign">

    <a-row :gutter="30" style="padding-top:30px;">
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">发布时间</a-col>
          <a-col span="18">
            <a-range-picker style="display:block" format="YYYY-MM-DD" v-model="select_time" />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:30px;">
        <a-row type="flex" align="top">
          <a-col span="4" class="form-label">标记人</a-col>
          <a-col span="20">
           <a-auto-complete
              style="display:block"
              placeholder="请输入关键字"
              v-model="params.ie_user_id"
              :dataSource="IEList"
              @search="handleSearchIE"
              @select="changeIE"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:30px;">
        <a-row type="flex" align="top">
          <a-input-group compact>
            <a-select
              class="select"
              defaultValue="user_name"
              @change="changeSelect"
            >
              <a-select-option value="user_name"
                >猎头姓名</a-select-option
              >
              <a-select-option value="tel">猎头电话</a-select-option>
            </a-select>
            <a-input
              style="width: 70%"
              placeholder="请输入关键字"
              v-model="selectValue"
            />
          </a-input-group>
        </a-row>
      </a-col>
    </a-row>

    <!-- 筛选和统计 -->
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button
          type="primary"
          style="margin-right:12px;padding:0 30px;"
          @click="handleFilter()"
          >筛选</a-button
        >
        <a-button style="margin-right:12px;" @click="resetParams"
          >清空筛选条件</a-button
        >
        <span>共找到 {{ total }} 条信息</span>
      </a-col>
      <a-col @click="showSignModal">
        <a-button type="primary"><a-icon type="plus" />标记</a-button>
      </a-col>
    </a-row>

    <a-divider></a-divider>

    <a-row :gutter="80" align="top">
      <a-col>
        <a-spin :spinning="loading" size="large">
          <a-table
            @change="getData"
            :pagination="pagination"
            :dataSource="listData"
            :columns="columns"
            rowKey="id"
          >
            <template slot="action" slot-scope="text, record">
              <a-row type="flex" :gutter="10" justify="start">
                <a-col><a @click.stop="release(record)">释放</a></a-col>
              </a-row>
            </template>
          </a-table>
        </a-spin>
      </a-col>
    </a-row>


    <a-modal v-model="signModal" title="标记用户">
      <template slot="footer">
        <a-button key="submit" type="primary" :loading="modelLoading" @click="sign">标记</a-button>
        <a-button key="back" @click="handleCancelReturn">取消</a-button>
      </template>
      <div style="margin-bottom: 10px">
        <span>用户手机号：</span><a-input style="margin-top:10px;" placeholder="输入手机号标记，标记的用户将不再参与人岗匹配" v-model="signTel" />
      </div>
      <div style="margin-bottom: 10px">
        <span>备注：</span>
        <a-textarea style="margin-top:10px;" placeholder="在此处添加备注，方便查询" :rows="4" v-model="reason" />
      </div>
    </a-modal>

  </div>
</template>

<script>

import moment from "moment";
import Api from "@/api";
import Pagination from "@/components/Pagination";
import baseComponentVue from "@/components/base-component.vue";

export default {
  name: "RecommendSign",
  extends: baseComponentVue,
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      select_time: [],
      total: 0,
      IEList: [],
      selectValue: '',
      listData: [],
      params: {
        created_start: '',
        created_end: '',
        ie_user_id: ''
      },
      clickRow: {},
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      columns: undefined,
      modelLoading: false,
      signModal: false,
      signTel: '',
      reason: '',


    }
  },
  created() {
    this.setColumns();
  },
  mounted() {
    this.resetParams();
    this.getData();
  },
  methods: {
    setColumns() {
      this.columns = [
        {
          title: '用户ID',
          dataIndex: 'user_id'
        },
        {
          title: "姓名",
          dataIndex: "name"
        },
        {
          title: "手机号",
          dataIndex: "tel"
        },
        {
          title: "标记理由",
          dataIndex: "reason"
        },
        {
          title: "标记人",
          dataIndex: "ie_user_name"
        },
        {
          title: "标记时间",
          dataIndex: "created_at"
        },
        {
          title: "释放",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ];
    },
    handleFilter() {
      this.getData();
    },
    resetParams() {
      this.params = {
        created_start: '',
        created_end: '',
        page: 1,
        limit: 10
      }
    },
    async handleSearchIE(value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.IEList = arr;
    },
    changeIE(value) {
      this.params.ie_user_id = value;
    },
    changeSelect(value) {
      this.params[value] = this.selectValue;
    },
    async getData(pagination) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      let params = {
        ...this.params,
        created_start: this.select_time[0] && this.select_time[0].format("YYYY-MM-DD"),
        created_end: this.select_time[1] && this.select_time[1].format("YYYY-MM-DD"),
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      console.log(params);
      let response = await Api.hunter.getRecommendBlackList(params);
      let { list } = await Api.hunter.getRecommendBlackList(params);
      this.loading = false;
      this.total = +response.total;
      this.listData = response.list;
    },
    showSignModal() {
      this.signModal = true;
      this.signTel = '';
      this.reason = '';
    },
    // 标记
    sign() {
      this.modelLoading = true;
      console.log(this.signTel, this.reason);
      let params = {
        tel: this.signTel,
        reason: this.reason
      }
      Api.hunter.createRecommendBlack(params).then( res => {
        console.log(res);
        if(res.result === 1) {
          this.$message.success('标记成功');
          this.modelLoading = false;
          this.signModal = false;
          this.getData();
        } else {
          this.$message.error('标记失败');
        }
      })
    },
    // 释放
    release(record) {
      console.log(record);
      this.$confirm({
        title: '提示',
        content: '确认要释放重新匹配该用户的简历资源？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          Api.hunter.deleteRecommendBlack({id: record.id}).then( res => {
            this.$message.success('释放成功');
            this.getData();
          }).catch(err => {
            this.$message.error('释放失败');
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      })

    },
    handleCancelReturn() {
      this.signModal = false;
    }
  },
};
</script>

<style lang="scss" scoped>



</style>
